module.exports = __webpack_public_path__ + "static/media/example-1.5c59d47c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Churchview/example-1.jpg
// module id = 226
// module chunks = 0